import React, { useState } from 'react';
import classnames from 'classnames';
import { ThemeOptions, ThemeSkin } from '@wix/da-react-context/pkg/constants';
import { useTranslation } from 'react-i18next';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import ThemeSwitchDark from '@wix/da-ds/pkg/Icons/ThemeSwitchDark/ThemeSwitchDark';
import ThemeSwitchLight from '@wix/da-ds/pkg/Icons/ThemeSwitchLight/ThemeSwitchLight';
import ThemeSwitchGreen from '@wix/da-ds/pkg/Icons/ThemeSwitchGreen/ThemeSwitchGreen';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';

import userDropdownStyles from '../UserMenuDesktop.scss';

export default ({ theme, setTheme, themeSkin, setThemeSkin }) => {
  const [currentTheme, setCurrentTheme] = useState(theme);
  const [currentThemeSkin, setCurrentThemeSkin] = useState(themeSkin);
  const { t } = useTranslation();

  return (
    <div className={userDropdownStyles['two-side-label']}>
      <span>{t('siteHeader.userMenu.mode')}</span>
      <span className={userDropdownStyles['theme-toggles']}>
        <BiSpan
          title={t('siteHeader.userMenu.themeDark')}
          onClick={() => {
            setCurrentThemeSkin(undefined);
            setCurrentTheme(ThemeOptions.DARK);
            yieldToMain(() => setTheme(ThemeOptions.DARK));
          }}
          className={classnames(
            userDropdownStyles['theme-toggle-item'],
            currentTheme === ThemeOptions.DARK &&
              !themeSkin &&
              userDropdownStyles['active']
          )}
          biData={BiData<TopNavMenuClickBiEvent>({
            evid: 702,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: 'dark',
          })}
        >
          <ThemeSwitchDark size={IconSize.LARGE} />
        </BiSpan>

        <BiSpan
          title={t('siteHeader.userMenu.themeLight')}
          onClick={() => {
            setCurrentThemeSkin(undefined);
            setCurrentTheme(ThemeOptions.LIGHT);
            yieldToMain(() => setTheme(ThemeOptions.LIGHT));
          }}
          className={classnames(
            userDropdownStyles['theme-toggle-item'],
            currentTheme === ThemeOptions.LIGHT &&
              !themeSkin &&
              userDropdownStyles['active']
          )}
          biData={BiData<TopNavMenuClickBiEvent>({
            evid: 702,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: 'light',
          })}
        >
          <ThemeSwitchLight size={IconSize.LARGE} />
        </BiSpan>

        <BiSpan
          title={t('siteHeader.userMenu.themeGreen')}
          onClick={() => {
            setCurrentTheme(ThemeOptions.LIGHT);
            setCurrentThemeSkin(ThemeSkin.GREEN);
            yieldToMain(() => setThemeSkin(ThemeSkin.GREEN));
          }}
          className={classnames(
            userDropdownStyles['theme-toggle-item'],
            currentThemeSkin === ThemeSkin.GREEN && userDropdownStyles['active']
          )}
          biData={BiData<TopNavMenuClickBiEvent>({
            evid: 702,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: 'green',
          })}
        >
          <ThemeSwitchGreen size={IconSize.LARGE} />
        </BiSpan>
      </span>
    </div>
  );
};
